<template>
    <div class="content page-3">
        <div>
            <section class="section-order section-white">
                <h2 class="text-green">
                    <h2 class="text-green">Velg rom for reisende:</h2>
                </h2>
                <div class="rooms" v-for="(room, i) in rooms" v-if="rooms.length">
                    <h3>Rom {{i + 1}}, {{ room.name }}:</h3>
                    <div class="split-row" v-for="person in $store.getters.personList"
                         v-if="shouldPersonBeVisible(i, person)">
                        <div class="checkbox">
                            <label>
                                <input type="checkbox" v-model="room.people" :value="person.id">
                                <span></span>
                                <span>{{person.firstName}} {{person.lastName}}</span>
                            </label>
                        </div>
                    </div>
                    <div class="split-row"
                         v-for="person in room.people.map(p => $store.getters.personList.find(pp => pp.id === p))"
                         v-if="roomIsFilled(i)">
                        <div class="checkbox">
                            <label>
                                <input type="checkbox" v-model="room.people" :value="person.id">
                                <span></span>
                                <span>{{person.firstName}} {{person.lastName}}</span>
                            </label>
                        </div>
                    </div>
                </div>
            </section>
        </div>

        <portal to="navButtons">
            <button class="checkout-button button button-fat fat-outline float-left"
                    @click="$router.push({name: 'page2'})">
                Tilbake
            </button>

            <button
                    class="checkout-button button button-fat float-right"
                    @click="goToNextStep"
                    :disabled="!canGoToNextStep">
                Fortsett
            </button>
        </portal>


        <portal to="overviewButtons">
            <button class="overview-button button button-fat w-100" @click="goToNextStep" :disabled="!canGoToNextStep">
                Fortsett til neste trinn
            </button>
        </portal>


    </div>
</template>
<script>

    export default {
        name: "Page21",
        data() {
            return {
                rooms: [],
            }
        },
        methods: {
            roomIsFilled(i) {
                if (i < 0) return true;
                return this.rooms[i].people.length === this.rooms[i].maxNrOfPeople
            },
            isPersonAssignedToRoom(personId, roomId) {
                return this.rooms[roomId].people.includes(personId)
            },
            reset() {
                let temporaryRooms = [];
                for (let roomId in this.$store.state.rooms) {
                    for (let id of this.$store.state.rooms[roomId]) {
                        let temp = this.$store.state.bookingData.roomSelections.find(ar => ar.Room.ProductUnitId == roomId)

                        temporaryRooms.push({
                            id: id,
                            roomId: roomId,
                            name: temp.Name,
                            minNrOfPeople: temp.MinNrOfTravelers,
                            maxNrOfPeople: temp.MaxNrOfTravelers,
                            people: []
                        })
                    }
                }
                this.rooms = temporaryRooms;
            },
            shouldPersonBeVisible(roomIndex, person) {
                return (this.roomIsFilled(roomIndex - 1) && !this.roomIsFilled(roomIndex)) &&
                    (this.isPersonAssignedToRoom(person.id, roomIndex) || !this.peopleAssignedToRooms.includes(person.id))
            },
            goToNextStep() {
                this.$router.push({name: 'page3'});
            },
        },
        computed: {
            peopleAssignedToRooms() {
                return this.rooms.map(r => r.people).flat()
            },

            canGoToNextStep: {
                cache: false,
                get() {
                    return this.$store.getters.allTravelersHasBeenAssignedARoom;
                },
            },
        },

        watch: {
            rooms: {
                deep: true,
                handler(value) {
                    this.$store.commit('updateRoomAssignments', value)
                }
            }
        },
        created() {
            if (this.$store.state.roomAssignments.length) {
                this.rooms = this.$store.state.roomAssignments
            } else {

                this.reset()
            }
        }
    };
</script>
